import { I18nService, LangText } from "@common/service/base-service/i18n";

/**
 *  安全送检，会遇到的规则问题
 *  每行代码，不可超过 120个字符
 */

/**
 * T: 实训的英文缩写
 * E/e: 实验的缩写
 */
const langText: LangText = {
  zh_CN: {
    haveNotCourseRes: "还没有配置课程资源哦",
    haveNotSearchCourseRes: "暂无相关结果,试试其他关键词吧...",
    courseCreate: "创建课程",
    allCourses: "全部课程",
    draft: "草稿",
    expired: "已过期",
    cancalPublished: "取消发布",
    stuMana: "学员管理",
    liveProcess: "正在直播",
    liveEnd: "直播结束"
  },
  en_US: {
    haveNotCourseRes: "Course resources have not been configured yet",
    haveNotSearchCourseRes: "No results yet, try other keywords...",
    courseCreate: "Create a course",
    allCourses: "Course List",
    draft: "Draft",
    expired: "Expired",
    cancalPublished: "Unpublish",
    stuMana: "Student Management",
    liveProcess: "Live broadcast",
    liveEnd: "Live broadcast ends"
  }
};

I18nService.setLang("front-courseMana", langText);

export { I18nService };
